import React, { useState, useEffect, useRef } from 'react';
import { dataService } from '../../Services/data/data.service';
import { makeStyles } from "@mui/styles";
import { AppBar, Typography, Box, Menu, MenuItem, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import WorkstationNotificationsDrawer from '../Workstation/WorkstationNotificationsDrawer';
import SelectedWorkstation from '../Workstation/SelectedWorkstation';
import { useLocation, Navigate, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import HeaderbarTimer from './HeaderbarTimer';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { MdLanguage } from 'react-icons/md'
import FlagstoneTheme from '../../Config/flagstoneTheme';
import i18n from '../../Helpers/translations';
import { HubConnectionBuilder } from '@microsoft/signalr';
// import $ from 'jquery';
// import * as signalR from 'signalr'; // Ensure you're using the correct import
import { Bell, Globe, LogOut, User } from 'lucide-react';


export const HeaderBar = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const userDropdownRef = useRef(null);
  const languageDropdownRef = useRef(null);

  const [selectedLanguage, setSelectedLanguage] = useState(null);
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);
  const [languageDropdownOpen, setLanguageDropdownOpen] = useState(false);

  const [notifications, setNotifications] = useState([]);
  const [notificationDrawerOpen, setNotificationDrawerOpen] = useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const appSettings = props.appSettings;

   useEffect(() => {
    const newNotificationConnection = new HubConnectionBuilder()
      .withUrl(appSettings.NOTIFICATION_HUB_URL)
      .withAutomaticReconnect()
      .build();
    newNotificationConnection.start().then(_ => {
      console.log('Notification hub connected!');
    }).catch(e => console.log('Notification hub connection failed: ', e));

    newNotificationConnection.on('ReceiveNotification', notificationData => {
      console.log(notificationData)
      props.actions.incrementCounter();
    });
  }, []);

  const navigate = useNavigate();
  let historyLocation = useLocation();

  useEffect(() => {
    if (userDropdownOpen || languageDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [userDropdownOpen, languageDropdownOpen]);

  const handleChangeLang = (lang) => {
    localStorage.setItem('lang', lang);
    i18n.changeLanguage(lang);
    setSelectedLanguage(lang)

    setLanguageDropdownOpen(false);
  };

  useEffect(() => {

    dataService.getLatestNotifications().then(logs => {
      let allNotifications = logs.data.Results;
      let filteredLogs = [];

      // Filter logs if there are active workstations
      if (props.workstation.activeWorkstations.length > 0) {
        filteredLogs = allNotifications.filter(notification => {
          // Parse the metaData field
          const metaData = JSON.parse(notification.MetaData);

          // Assuming 'MetaData' array exists, and you're interested in 'MachineId'
          const machineId = metaData[0]?.MetaData[0]?.MachineId;

          // Check if the machineId is in the active workstations
          return props.workstation.activeWorkstations.some(x => x.Id === machineId);
        });
      }

      // Sort logs by insertedOn date
      logs = filteredLogs.sort((a, b) => new Date(b.InsertedOn) - new Date(a.InsertedOn));
      setNotifications(logs);
    });
  }, [props.workstation.activeWorkstations, props.notification.counter]);

  const openNotificationsDrawer = (open) => {
    if (!open) {
      props.actions.setCounter(0);
    }

    setNotificationDrawerOpen(open);
  }

  const logout = () => {
    props.actions.logout();

    setUserDropdownOpen(false);
  }

  useEffect(() => {
    console.log(selectedLanguage)
    if (selectedLanguage === null) {
      switch (i18n.language) {
        case 'NL':
          setSelectedLanguage('NL');
          break;
        case 'FR':
          handleChangeLang('FR');
          break;
        case 'US':
          setSelectedLanguage('EN');
          break;
        default:
          handleChangeLang('FR');
          break;
      }
    }
  }, []);


  const selectLine = (workstationId) => {
    if (historyLocation.pathname.includes("/order/")) {

    }
    else {
      props.actions.setSelectedWorkstation(workstationId);
    }
  }

  const goToLogin = () => {
    navigate("/login", { replace: true, state: { from: historyLocation } });
  }

  const toggleUserDropdown = () => {
    setUserDropdownOpen(!userDropdownOpen);
  }

  const toggleLanguageDropdown = () => {
    setLanguageDropdownOpen(!languageDropdownOpen);
  }

  const handleClickOutside = (event) => {
    if (userDropdownRef.current && !userDropdownRef.current.contains(event.target)) {
      setTimeout(() => {
        setUserDropdownOpen(false);
      }, 100);
    }

    if (languageDropdownRef.current && !languageDropdownRef.current.contains(event.target)) {
      setTimeout(() => {
        setLanguageDropdownOpen(false);
      }, 100);
    }
  };

  return <React.Fragment>
    <AppBar className={classes.appBar} position="fixed">
      <div className={classes.logoContainer}>
        <div className={classes.logo}>
          <div className={classes.logo__pallet}>
            PALLET
          </div>
          <div className={classes.logo__validation}>
            VALIDATION
          </div>
        </div>
        <HeaderbarTimer />
      </div>
      <div className={classes.lines}>
        <div className={classes.lineText}>{props.workstation !== null && props.workstation !== undefined && props.workstation.activeWorkstations.length > 0 ? (t('Checkpoint')).toUpperCase() : ""}</div>
        {(props.workstation !== null && props.workstation !== undefined) && props.workstation.activeWorkstations.map(x => { return (x.Id === props.workstation.selectedWorkstation ? <SelectedWorkstation key={x.Id} line={x.Code} id={x.Id} {...props}></SelectedWorkstation> : <button onClick={() => selectLine(x.Id)} className={classes.line} key={x.Id}>{x.Code}</button>) })}
      </div>

      <div className={classes.appBar__controls}>
        <div className={classes.languageContainer}>
          <button className={classes.languageButton} onClick={(e) => toggleLanguageDropdown(e)}>
            <p className={classes.languageButton__text}>{selectedLanguage}</p>
            <Globe size={24} className={classes.languageButton__icon} />
          </button>
          {languageDropdownOpen &&
            <div className={classes.language__dropdown} ref={languageDropdownRef}>
              <button onClick={() => handleChangeLang('NL')} className={classes.user__dropdownButton} style={{}}>Nederlands</button>
              <button onClick={() => handleChangeLang('FR')} className={classes.user__dropdownButton}>Français</button>
              <button onClick={() => handleChangeLang('EN')} className={classes.user__dropdownButton}>English</button>
            </div>
          }
        </div>
        <div className={classes.userInfoAndNotifications}>
          <div className={classes.userContainer}>
            {props.nav.user === null || props.nav.user === undefined ?
              <button className={classes.loginButton} onClick={() => goToLogin()}>
                Login
              </button> :
              <button aria-controls="simple-menu" aria-haspopup="true" className={classes.user} onClick={() => toggleUserDropdown()}>
                <User className={classes.user__icon} />
                <div className={classes.user__name}>{props.nav.user ? props.nav.user.Name : ""}</div>
              </button>
            }
            {userDropdownOpen &&
              <div className={classes.user__dropdown} ref={userDropdownRef}>
                <button onClick={() => logout()} className={`${classes.user__dropdownButton} ${classes.logout}`}>
                  <LogOut className={classes.user__dropdownButtonIcon} />
                  {t('Logout')}
                </button>
              </div>
            }
          </div>
          <button className={classes.notifications} onClick={() => setNotificationDrawerOpen(true)}>
            <Bell size={24} />
            {props.notification.counter > 0 ? <div className={classes.unread}>{props.notification.counter > 99 ? "+99" : props.notification.counter}</div> : <React.Fragment></React.Fragment>}
          </button>
        </div>
      </div>

    </AppBar>
    <WorkstationNotificationsDrawer closeDrawer={() => openNotificationsDrawer(false)} notifications={notifications} openDrawer={openNotificationsDrawer} drawerOpen={notificationDrawerOpen} {...props}></WorkstationNotificationsDrawer>
  </React.Fragment>
}

const useStyles = makeStyles((theme) => ({
  appBar: {
    height: 'fit-content !important',
    minHeight: "50px !important",
    backgroundColor: '#EFEFEF !important',
    boxShadow: "none !important",
    borderBottom: "1px solid #DEDEDE !important",
    paddingRight: "20px !important",
    padding: "4px 20px 4px 0px",

    [theme.breakpoints.down('sm')]: {
      height: "80px",
    },
    textAlign: "center !important",
    display: 'flex !important',
    flexDirection: 'row !important',
    justifyContent: 'space-between !important',
    alignItems: 'center !important',
  },

  logoContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: "center",
    gap: "24px",

    marginLeft: "70px",
  },

  logo: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },

  logo__pallet: {
    fontSize: "14px",
    fontFamily: "Campton-bold",
    color: FlagstoneTheme.palette.primary.main,
  },

  logo__validation: {
    fontSize: "14px",
    fontFamily: "Campton-bold",
    color: FlagstoneTheme.palette.text.primary,
    marginTop: "-4px"
  },

  lines: {
    display: "inline",
    position: "relative",
  },

  lineText: {
    fontSize: "14px",
    fontFamily: "Lato, sans-serif",
    color: "#020100",
    display: "inline",
    marginRight: "10px"
  },

  line: {
    fontSize: "14px",
    fontFamily: "Lato, sans-serif",
    color: "#020100",
    display: "inline",
    outline: "none",
    cursor: "pointer",
    border: "none"
  },

  appBar__controls: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "24px",
  },

  selectedLanguageTextStyle: {
    fontSize: "20px",
    fontFamily: "Lato, sans-serif",
    color: FlagstoneTheme.palette.primary.fontColor,
  },

  settingsIconStyle: {
    marginRight: "25px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    border: "none",
  },

  languageContainer: {
    height: "42px",
    position: "relative",
    display: 'flex',
  },

  languageButton: {
    border: "none",
    backgroundColor: "transparent",
    outline: "none",
    cursor: "pointer",

    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "8px",

    height: "100%",
    padding: "0 12px",
    borderRadius: "4px",

    "&:hover": {
      backgroundColor: "#DCDCDC",
      transition: "background-color 0.2s"
    }
  },

  languageButton__icon: {
    color: FlagstoneTheme.palette.primary.main,
    height: "24px",
    width: "24px",
  },

  languageButton__text: {
    fontSize: "16px",
    fontFamily: "Lato, sans-serif",
    color: FlagstoneTheme.palette.text.primary,
  },

  language__dropdown: {
    position: "absolute",
    top: "calc(100% + 4px)",
    right: "0px",

    width: "fit-content",
    padding: "4px",

    borderRadius: "6px",
    backgroundColor: "white",

    boxShadow: "0px 3px 12px rgba(175, 175, 175, 0.25)",
  },

  userInfoAndNotifications: {
    height: "42px",
    display: 'flex',
    alignItems: 'center',
    gap: "4px",
  },

  userContainer: {
    position: "relative",
    height: "100%",
  },

  loginButton: {
    color: "white !important",
    fontSize: "16px !important",
    fontWeight: "normal !important",
    fontFamily: "Lato, sans-serif !important",
    backgroundColor: FlagstoneTheme.palette.primary.main + " !important",
    border: "1px solid " + FlagstoneTheme.palette.primary.main + " !important",
    minWidth: "fit-content !important",
    height: '42px !important',
    padding: '0px 24px !important',
    textTransform: "none !important",
    borderRadius: "4px !important",

    transition: "all 0.2s !important",

    '&:hover': {
      backgroundColor: "#3B3AF1 !important",
      cursor: "pointer !important",
    },

    '&:disabled': {
      backgroundColor: "lightgrey !important",
      color: "white !important",
      border: "1px solid darkgrey !important",
      cursor: "not-allowed !important"
    },
  },

  user: {
    border: "none",
    backgroundColor: "transparent",
    outline: "none",
    cursor: "pointer",

    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "8px",

    height: "100%",
    padding: "0 12px",
    borderRadius: "4px",

    "&:hover": {
      backgroundColor: "#DCDCDC",
      transition: "background-color 0.2s"
    }
  },

  user__icon: {
    color: FlagstoneTheme.palette.text.primary,
    height: "24px",
    width: "24px",
  },

  user__name: {
    fontSize: "16px",
    fontFamily: "Lato, sans-serif",
    color: FlagstoneTheme.palette.text.primary,
  },

  user__dropdown: {
    position: "absolute",
    top: "calc(100% + 4px)",
    right: "0px",

    width: "120px",
    padding: "4px",

    borderRadius: "6px",
    backgroundColor: "white",

    boxShadow: "0px 3px 12px rgba(175, 175, 175, 0.25)",
  },

  user__dropdownButton: {
    border: "none",
    backgroundColor: "transparent",
    borderRadius: "4px",

    height: "28px",
    width: "100%",

    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",

    fontSize: "14px",
    fontFamily: "Lato, sans-serif",
    color: FlagstoneTheme.palette.text.primary,
    cursor: "pointer",

    "&:hover": {
      backgroundColor: "#EDEDED",
      transition: "background-color 0.2s"
    },
  },

  logout: {
    color: FlagstoneTheme.palette.red.main,
    justifyContent: "space-between",

    "&:hover": {
      color: "#F8F8F8",
      backgroundColor: FlagstoneTheme.palette.red.main,
      transition: "background-color 0.2s"
    },
  },

  user__dropdownButtonIcon: {
    width: "16px",
    height: "16px",
  },

  languageSelectButton: {
    border: "1px solid",
    borderColor: FlagstoneTheme.palette.primary.main,
    fontFamily: "Lato, sans-serif",
    fontSize: "16px",
    color: FlagstoneTheme.palette.primary.fontColor,
    padding: "15px",
    backgroundColor: "white",
    cursor: "pointer",
    width: "70px",
    '&:hover': {
      backgroundColor: FlagstoneTheme.palette.primary.main,
      color: "white",
    }
  },

  selectedLanguageButton: {
    backgroundColor: FlagstoneTheme.palette.primary.main,
    color: "white",
  },

  notifications: {
    border: "none",
    outline: "none",
    cursor: "pointer",
    height: "100%",
    padding: "0 12px",
    backgroundColor: "transparent",
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",

    position: "relative",

    "&:hover": {
      backgroundColor: "#DCDCDC",
      transition: "background-color 0.2s"
    }
  },

  notificationsIcon: {
    height: "24px",
    width: "24px",
  },

  unread: {
    width: "17px",
    height: "17px",
    borderRadius: "50%",
    backgroundColor: "#D84949",
    position: "absolute",
    top: "2px",
    right: "6px",
    color: "white",
    fontSize: "10px",
    fontFamily: "Lato, sans-serif",
    fontWeight: "bold",
    paddingTop: "2px",
    boxSizing: "border-box"
  },
}));
function mapStateToProps(state) {
  return {
    user: state.user,
    notification: state.notification,
    workstation: state.workstation,
  }
}

export default connect(mapStateToProps)(HeaderBar)
